import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <nav className="bg-gray-800 border-b border-gray-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-xl font-bold text-blue-400 hover:text-blue-300 transition-colors duration-200">
              AI Art Generator
            </Link>
          </div>
          <div className="flex items-center space-x-6">
            <Link to="/generate" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">
              生成
            </Link>
            <Link to="/gallery" className="text-gray-300 hover:text-blue-400 transition-colors duration-200">
              画廊
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
